import Immutable, {List, Map} from 'immutable';
import Axios from 'axios';

import * as AcceptFactorChangeMode from 'constants/AcceptFactorChange';
import * as BetType from 'constants/BetType';
import * as resources from 'constants/accountResourceNames';
import { minAmount } from 'constants/StakeMinAmount';
import { maxAmount } from 'constants/StakeMaxAmount';

import * as ActionTypes from '../CouponRate';

import {makeBet} from './MakeBet';
import {balance} from '../balance/balanceAction';
import {requestBetTypes} from './HistoryBet';
import { isMinAndMaxValueWrong } from '../../sport-betting/components/bet-panel-control/CouponDropDownMenu.jsx';

export function addCouponRate(data) {
    try {
        Axios.post(`/api/actions/set?type=rate`)
    } catch (error) {}
    return {type: ActionTypes.ADD_COUPON_RATE, data};
}

export function removeCouponRate(data) {
    return (dispatch, getState) => {
        const betSlips = getState().application.getIn(['coupon', 'betSlips']);

        if (betSlips.size === 1) {
            return dispatch(removeCouponRates(data));
        } else {
            return dispatch({type: ActionTypes.REMOVE_COUPON_RATE, data});
        }
    }
}

export function removeCouponRates(data) {
    return {type: ActionTypes.REMOVE_COUPON_RATES, data};
}

export function setCouponBetType(data) {
    return {type: ActionTypes.SET_COUPON_BET_TYPE, data};
}

export function setCouponAmount(data) {
    return {type: ActionTypes.SET_COUPON_AMOUNT, data};
}

export function acceptRateValueChange(data) {
    return {type: ActionTypes.ACCEPT_RATE_VALUE_CHANGE, data};
}

export function addRate(data) {
    return (dispatch, getState) => {
        const {rate, match, outcome, score} = data;

        const bettingMode = getState().application.get('bettingMode');
        let oneClickMode = bettingMode.get('isOneClick');

        const betHistory = getState().application.get('betHistory');
        const user = getState().auth.get('user');


        const acceptFactorChangeMode = bettingMode.get('acceptFactorChange');
        const oneClickAmount = bettingMode.get('oneClickAmount') || 50;
        const isVerified = user && user.get('isVerified');

        if (user) {
            const resourceId = user.get('resourceId');
            const currency = resources.resourceNames[resourceId];
            const minStakeAmount = minAmount[currency];
            const maxStakeAmount = maxAmount[currency];

            if(isMinAndMaxValueWrong(minStakeAmount, maxStakeAmount, oneClickAmount)) {
                oneClickMode = false;
            }
        }

        if (oneClickMode) {
            const accountId = user.get('accountId');

            let allowIncrease = false;
            let allowDecrease = false;

            if (acceptFactorChangeMode === AcceptFactorChangeMode.INCREASE) {
                allowIncrease = true;
            } else if (acceptFactorChangeMode === AcceptFactorChangeMode.DECREASE) {
                allowDecrease = true;
            } else if (acceptFactorChangeMode === AcceptFactorChangeMode.BOTH) {
                allowIncrease = true;
                allowDecrease = true;
            }

            const odd = rate.get('value');
            const betId = betHistory.size > 0 ? (parseInt(betHistory.keySeq().maxBy(x => parseInt(x))) + 1) : '1';

            const bets = [];
            const historyBets = [];

            const rateId = rate.get('id');

            let factors = new List().push(new Map({
                eventId: match.get('id'),
                eventTimeAndZone: match.get('timeAndZone'),
                outcomeId: outcome.get('id'),
                factorId: rateId,
                factorValue: rate.get('value'),
                isConditional: false
            }));

            bets.push({
                id: betId.toString(),
                type: BetType.SINGLE,
                rank: undefined,
                amount: oneClickAmount,
                factorValue: odd,
                factors,
                oneClick: true,
                allowIncrease,
                allowDecrease,
                isFreebet: false
            });

            let rates = new Map().set(rateId,
                Immutable.fromJS({
                    rate,
                    outcome: {
                        name: outcome.get('name')
                    },
                    match: {
                        timeAndZone: match.get('timeAndZone'),
                        name: match.get('name')
                    },
                    score: {
                        score1: score ? score.get('score1') : undefined,
                        score2: score ? score.get('score2') : undefined
                    }
                }));

            historyBets.push({
                id: betId.toString(),
                betType: BetType.SINGLE,
                rank: undefined,
                amount: oneClickAmount,
                odd,
                betSlips: rates
            });

            if (isVerified === false) {
                window.toggleVerifyModal && window.toggleVerifyModal(true)
            } else {
                dispatch(makeBet(bets, historyBets));
            }
            return dispatch(balance(accountId));
        }

        dispatch(addCouponRate({
            rate,
            match,
            outcome,
            score
        }));
        return dispatch(requestBetTypes());
    };
}

export function changeCouponSlipAmount(data) {
    return {type: ActionTypes.CHANGE_COUPON_SLIP_AMOUNT, data};
}


// WEBPACK FOOTER //
// ./js/actions/creators/CouponRate.js